/* ALX Mobile Other Size -> measurement inputs. Draft theme only; prices untouched. */
(function () {
  if (!/\/products\/[^/]*(drain|garage-drain)/i.test(location.pathname)) return;
  var media = matchMedia('(max-width: 820px) and (pointer: coarse)');
  var pending = false, started = 0, variantUpdated = false, timer = null;

  function isOtherSize(el) {
    if (!el || !el.matches('variant-picker select.product-form__single-selector')) return false;
    var option = el.options[el.selectedIndex];
    return option && /other\s*(size|dimension|measure)|autre(?:s)?\s*(mesure|taille|dimension)|sur\s*mesure/i.test(option.textContent || '');
  }

  function axis(input) {
    if (!input.matches('input[type="number"],input[type="text"]') || input.closest('variant-picker')) return null;
    function parse(text) {
      var l = /\b(length|longueur)\b/i.test(text);
      var w = /\b(width|largeur)\b/i.test(text);
      return l === w ? null : l ? 'length' : 'width';
    }
    var texts = [input.name || '', input.id || '', input.getAttribute('aria-label') || ''];
    if (input.labels) Array.from(input.labels).forEach(function (el) { texts.push(el.textContent || ''); });
    var known = parse(texts.join(' '));
    if (known) return known;
    var parent = input.parentElement;
    for (var n = 0; parent && n < 3; n++, parent = parent.parentElement) {
      var label = parent.querySelector('label');
      if (label) {
        known = parse(label.textContent || '');
        if (known) return known;
      }
    }
    return null;
  }

  function findFields() {
    var fields = {};
    document.querySelectorAll('input[type="number"],input[type="text"]').forEach(function (input) {
      if (!input.getClientRects().length) return;
      var name = axis(input);
      if (name && !fields[name]) fields[name] = input;
    });
    return fields;
  }

  function closePicker() {
    var active = document.activeElement;
    if (active && active.matches && active.matches('variant-picker select')) active.blur();
  }

  function attempt() {
    if (!pending) return;
    closePicker();
    var elapsed = Date.now() - started;
    if (elapsed > 3000) { pending = false; return; }
    if (!variantUpdated && elapsed < 450) return;
    var fields = findFields();
    if (!fields.length || !fields.width) return;
    pending = false;
    fields.length.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { fields.length.focus({ preventScroll: true }); }
    catch (e) { fields.length.focus(); }
  }

  function schedule(delay) {
    setTimeout(attempt, delay);
  }

  document.addEventListener('change', function (event) {
    if (!media.matches || !isOtherSize(event.target)) return;
    pending = true;
    started = Date.now();
    variantUpdated = false;
    event.target.blur();
    [90, 250, 450, 700, 1100, 1700, 2400, 3000].forEach(schedule);
  }, true);

  document.addEventListener('variant:changed', function () {
    if (!pending) return;
    variantUpdated = true;
    closePicker();
    schedule(130);
    schedule(350);
  });

  new MutationObserver(function () {
    if (!pending) return;
    clearTimeout(timer);
    timer = setTimeout(attempt, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
